<template>
  <div class="container-cap">
    <component :is="component"
               :surveillance="surveillance"
               :year="year"
               :module="module"
               :config="config">
    </component>
  </div>
</template>
<script>
import generic from '@/components/establishments/dashboard/generic'
import reasink from '@/components/establishments/dashboard/reasink'
import explaur from '@/components/establishments/dashboard/explaur'
import topcvp from '@/components/establishments/dashboard/topcvp'

export default {
  name: 'sheet-dashboard',

  props: {
    surveillance: {
      type: Object
    },

    config: {
      type: Object,
      required: true
    }
  },

  data: function () {
    return {
      pages: {
        reaSink: 'reasink',
        reaExplaur: 'explaur',
        topCvp: 'topcvp'
      }
    }
  },

  computed: {
    year: function () {
      return this.$route.params.year
    },

    module: function () {
      return this.$route.params.st
    },

    component: function () {
      const p = this.pages[this.module]
      if (p == null) {
        return 'generic'
      }

      return p
    }
  },

  methods: {
    checkRoute: function (to, from, next) {
      next()
    }
  },

  components: {
    'generic': generic,
    'reasink': reasink,
    'explaur': explaur,
    'topcvp': topcvp
  }
}
</script>
<style scoped lang="less">
</style>
